module.exports = __webpack_public_path__ + "static/img/loading-9-16.6e8a448.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/loading/loading-9-16.jpg
// module id = Wn+h
// module chunks = 0